export default "__VITE_ASSET__d3d7567a__"